import { render, staticRenderFns } from "./UserPass.vue?vue&type=template&id=f37c4f0a&scoped=true"
import script from "./UserPass.vue?vue&type=script&lang=js"
export * from "./UserPass.vue?vue&type=script&lang=js"
import style0 from "./UserPass.vue?vue&type=style&index=0&id=f37c4f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37c4f0a",
  null
  
)

export default component.exports